import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

// components
import { BackToResults, SearchAgain } from '../../common';
import SearchForm from '../search-form';
import AgentDetails from './AgentDetails';

// utilities
import { configs } from '@constants/configs/configs';

// hooks
import useAgentListing from '../useAgentListing';

// types

// styles

const StyleHeaderLinks = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 2% 0 2% 0;

    .link {
        color: #00AC69;
        align-self: center;
    }
`;

const StyleMainContent = styled.div`
    padding: 0 0 2% 0;
    font-size: 2rem;
    opacity: 0.6;
`;

function AgentDetailsContainer() {
    
    const [ showSearchForm, setShowSearchForm ] = useState(false);
    const [ searchCriteria, setSearchCriteria ] = useState(null);
    const location = useLocation();
    const { data, isError, searchAgentListingByLocation, searchAgentListingByName } = useAgentListing();
    const navigate = useNavigate();

    const {
        routes: {
            ANON_GA_AGENTS
        }
    } = configs;

    useEffect(() => {
        if (data) {
            navigate(ANON_GA_AGENTS, {
                state: {
                    searchCriteria,
                    agentListData: data?.payload?.content,
                    isError: false
                }
            });
        } else if (isError) {
            navigate(ANON_GA_AGENTS, {
                state: {
                    searchCriteria,
                    agentListData: data?.payload?.content,
                    isError: isError
                }
            });
        }
    }, [data]);

    const HeaderLinks = () => {
        return (
            <>
                <StyleHeaderLinks>
                    <div><BackToResults to={ANON_GA_AGENTS}/></div>
                    <div><SearchAgain onClickHandler={setShowSearchForm}/></div>
                </StyleHeaderLinks>
            </>
        );
    };

    const MainContent = () => {
        return (
            <StyleMainContent><FormattedMessage id='ga.agent.details.main.text' /></StyleMainContent>
        );
    };

    const onHideSearchFormHandler = () => {
        setShowSearchForm(false);
    };

    const onSearchFormHandler = (isZipcodeSearch: boolean, inputFormData: any) => {
        setShowSearchForm(false);
        setSearchCriteria({ isZipResults: isZipcodeSearch, ...inputFormData });
      
        const pageNumber = 0;
        isZipcodeSearch ? searchAgentListingByLocation(pageNumber, inputFormData) : searchAgentListingByName(pageNumber, inputFormData);
    };

    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="gaep-agent-listing">
            <div className="grid-container gi-grid-container">
                <HeaderLinks />
                <MainContent />
                <AgentDetails {...location.state} />
            </div>
            {
                showSearchForm &&
                <SearchForm show={showSearchForm} onSearch={onSearchFormHandler} onHide={onHideSearchFormHandler} />
            }
        </main>
    );
}

export default AgentDetailsContainer;